var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnInit, } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../base.component';
import { SuccessWrapComponent } from '../success.wrap/success.wrap.component';
var ImageSelectorComponent = /** @class */ (function (_super) {
    __extends(ImageSelectorComponent, _super);
    function ImageSelectorComponent(imageService) {
        var _this = _super.call(this) || this;
        _this.imageService = imageService;
        _this.sizeLimit = config.eventImageSizeLimit;
        _this.isSimple = false;
        _this.isShowUploadIcon = true;
        _this.label = 'SELECT YOUR IMAGE (PNG/JPG/GIF)';
        _this.label2 = '';
        _this.updateLabel = 'UPDATE YOUR IMAGE';
        _this.onUpload = new EventEmitter();
        _this.onImageChanged = new EventEmitter();
        _this.isShowUploadingSpinner = false;
        return _this;
    }
    ImageSelectorComponent.prototype.ngOnInit = function () { };
    ImageSelectorComponent.prototype.onImageChange = function ($event) {
        var _this = this;
        this.command.image = $event.srcElement.files[0];
        if (!!this.command.image) {
            //if (this.command.image.size <= this.sizeLimit) {
            var reader = new FileReader();
            reader.onload = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var imageFile;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.selectedImageData = e.target['result'];
                            return [4 /*yield*/, this.imageService.compressImageFile(this.command.image)];
                        case 1:
                            imageFile = _a.sent();
                            this.onImageChanged.emit(imageFile);
                            return [2 /*return*/];
                    }
                });
            }); };
            reader.readAsDataURL(this.command.image);
            // } else {
            //     window.alert('This image is too large!');
            //     this.imageSelector.nativeElement.value = '';
            // }
        }
    };
    ImageSelectorComponent.prototype.clearImage = function () {
        this.command.image = null;
        this.selectedImageData = null;
        this.imageSelector.nativeElement.value = '';
        this.onImageChanged.emit(null);
    };
    ImageSelectorComponent.prototype.updateImage = function () {
        this.onUpload.emit(this.command.image);
    };
    ImageSelectorComponent.prototype.safeImage = function () {
        return this.imageService.safeImage(this.imageService.imageSourceUrl(this.selectedImageData));
    };
    ImageSelectorComponent.prototype.showSpinner = function () {
        this.isShowUploadingSpinner = true;
    };
    ImageSelectorComponent.prototype.hideSpinner = function () {
        this.isShowUploadingSpinner = false;
    };
    return ImageSelectorComponent;
}(BaseComponent));
export { ImageSelectorComponent };
var ImageSelectorCommand = /** @class */ (function () {
    function ImageSelectorCommand() {
    }
    return ImageSelectorCommand;
}());
export { ImageSelectorCommand };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image.selector/image.selector.component.ts.pre-build-optimizer.js